import { Box, Link, Typography } from '@mui/material';
import { createAnalyticsTracker } from 'v2/analytics/events';

const trackComplianceLinkEvents = createAnalyticsTracker('complianceLinks');

export const ComplianceLinks = () => (
  <Box mb={2}>
    <Typography variant="caption">
      By clicking Sign Up, you agree to our{' '}
      <Link
        onClick={() =>
          trackComplianceLinkEvents({ eventName: 'Terms of Services' })
        }
        href="https://www.enterpret.com/terms"
        target="_blank"
        rel="noreferrer"
      >
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link
        onClick={() =>
          trackComplianceLinkEvents({ eventName: 'Privacy Policy' })
        }
        href="https://www.enterpret.com/privacy-and-policy"
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </Link>
      .
    </Typography>
  </Box>
);
